import React from 'react';
import * as Styled from '../../styled';
import _ from 'lodash';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { AccountFilterElements } from '../AccountFilterElements';
import { FilterElements } from '../../FilterElements';

interface Props {
	ageMin: string;
	ageMax: string;
	formikProps: any;
}

const AgeFilter = (props: Props) => {
	const { handleChange, errors } = props.formikProps;
	return (
		<React.Fragment>
			<Styled.LeftSubCol md="6" sm="12">
				<Styled.FilterLabel label="Min. age">
					<Styled.ValidatedInput
						name="ageMin"
						placeholder="Any"
						onChange={handleChange}
						value={props.ageMin}
						error={errors.ageMin}
						data-id={AccountFilterElements.minAgeFilterId}
						aria-describedby={AccountFilterElements.ageErrorId}
						className={
							errors.ageMax || errors.ageMin
								? FilterElements.validationError
								: null
						}
					/>
				</Styled.FilterLabel>
			</Styled.LeftSubCol>
			<Styled.RightSubCol md="6" sm="12">
				<Styled.FilterLabel label="Max. age">
					<Styled.ValidatedInput
						name="ageMax"
						placeholder="Any"
						onChange={handleChange}
						value={props.ageMax}
						error={errors.ageMax || errors.ageMin}
						data-id={AccountFilterElements.maxAgeFilterId}
						aria-describedby={AccountFilterElements.ageErrorId}
					/>
				</Styled.FilterLabel>
			</Styled.RightSubCol>
			<Styled.SingleSubCol col="12">
				{errors.ageMin || errors.ageMax ? (
					<Styled.ValidationError
						id={AccountFilterElements.ageErrorId}
						data-id={AccountFilterElements.ageErrorId}
					>
						<Styled.ErrorIcon icon={faExclamationTriangle} />
						<span className="sr-only">Error, </span>
						{errors.ageMax || errors.ageMin}
					</Styled.ValidationError>
				) : null}
			</Styled.SingleSubCol>
		</React.Fragment>
	);
};

export default AgeFilter;
